import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Splash from './pages/splash';
import Home from './pages/home';
import backgroundmusic from './audio/backgroundmusic.mp4'
import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import Levelspage from './pages/levels';
import Story from './pages/story';
import { useLocation } from 'react-router-dom';
import Characters from './pages/characters';
import AudioContext from './components/common/AudioContext';
import Level1 from './pages/level1';
import Howtoplayinstructions from './pages/howtoplayinstructions';
import Misson from './pages/Misson';
import Level1start from './pages/level1-start';
import Losing from './pages/losing';
import Pause from './components/common/pause';
import Exit from './components/common/Exit';
import Wining from './pages/wining';
import Unlocknewcharcter from './pages/unlockedcharacter';
import Unlocknewcharacter from './pages/unlockedcharacter';
import Level2unlocked from './pages/level2unlocked';
import Level2start from './pages/level2-start';
import Level2 from './pages/level2';
import Level3unlocked from './pages/level3unlocked';
import Level3start from './pages/level3-start';
import Level3 from './pages/level3';
import Level4unlocked from './pages/level4unlocked';
import Level4start from './pages/level4-start';
import Level4 from './pages/level4';
import Level5unlocked from './pages/level5unlocked';

const AudioController = ({ audioRef, musicVolume }) => {
  const location = useLocation();

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    if (
      location.pathname === '/Story' ||
      location.pathname === '/Howtoplayinstructions' ||
      location.pathname === '/Misson' ||
      location.pathname === '/Level1start'||
      location.pathname === '/Level2start'||
      location.pathname === '/Level3start'||
       location.pathname === '/Level4start'
    ) {
      audio.volume = musicVolume * 0.2;
    } else {
      audio.volume = musicVolume;
    }
    }, [location.pathname, audioRef, musicVolume]);

    return null;
};

const Paths = () => {
    const audioRef = useRef(null);
    const [started, setStarted] = useState(false);
    const [musicVolume, setMusicVolume] = useState(1);
    const [soundVolume, setSoundVolume] = useState(1);

    useEffect(() => {
    const images = require.context('./assets', false, /\.png$/);

        images.keys().forEach((key) => {
            const img = new Image();
            img.src = images(key);
        });
    }, []);

    const handleMusicVolume = (val) => {
        setMusicVolume(val);
        if (audioRef.current) audioRef.current.volume = val;
    };

    useEffect(() => {
        const allAudio = document.querySelectorAll('audio:not([data-bg])');
        allAudio.forEach(a => a.volume = soundVolume);
    }, [soundVolume]);

    useEffect(() => {
        if (started) return;
        const startAudio = () => {
            const audio = audioRef.current;
            if (!audio) return;
            audio.volume = musicVolume;
            audio.play().catch(() => {});
            setStarted(true);
            document.removeEventListener('click', startAudio);
            document.removeEventListener('touchstart', startAudio);
            document.removeEventListener('keydown', startAudio);
        };
        document.addEventListener('click', startAudio);
        document.addEventListener('touchstart', startAudio);
        document.addEventListener('keydown', startAudio);
        return () => {
            document.removeEventListener('click', startAudio);
            document.removeEventListener('touchstart', startAudio);
            document.removeEventListener('keydown', startAudio);
        };
    }, [started]);

    return ( 

 <>
           <AudioContext.Provider value={{ musicVolume, soundVolume, handleMusicVolume, setSoundVolume }}>
            <audio ref={audioRef} src={backgroundmusic} loop preload="auto" data-bg />
          <BrowserRouter>
               <AudioController audioRef={audioRef} musicVolume={musicVolume} />
                <Routes>
                <Route path='/'  element={<Splash />} /> 
                 <Route path='/home'  element={  <Home />  } />    
                <Route  path='/levels'  element={  <Levelspage /> }/>  
                <Route  path='/Story'  element={ <Story /> }/>  
                <Route  path='/characters'  element={ <Characters /> }/>  
                <Route path='/level1' element={<Level1 />}></Route>
                <Route  path='/Howtoplayinstructions'  element={   <Howtoplayinstructions/> }/>  
               <Route  path='/Misson'  element={   <Misson />   }/>  
               <Route  path='/Level1start'  element={   <Level1start />  }/>                
              <Route  path='/losing'  element={   <Losing /> }/>                              
              <Route  path='/Pause'  element={   <Pause /> }/>       
              <Route  path='/exit'  element={   <Exit /> }/>   
              <Route  path='/Wining'  element={  <Wining/> }/>    
             <Route  path='/unlockedcharacter'  element={  <Unlocknewcharacter /> }/>    
              <Route  path='/level2unlocked'  element={  <Level2unlocked /> }/>
               <Route  path='/Level2start'  element={   <Level2start />  }/>  
               <Route  path='/Level2'  element={   <Level2/> }/>  
              <Route  path='/level3unlocked'  element={  <Level3unlocked /> }/>             
               <Route  path='/Level3start'  element={   <Level3start />  }/>  
               <Route  path='/Level3'  element={   <Level3 /> }/>         
               <Route  path='/level4unlocked'  element={  <Level4unlocked/> }/>           
               <Route  path='/level4start'  element={  <Level4start/> }/>  
               <Route  path='/Level4'  element={   <Level4 /> }/>   
               <Route  path='/level5unlocked'  element={  <Level5unlocked/> }/>   
        </Routes>
        </BrowserRouter>    
     </AudioContext.Provider>     
        </>

     );
}
 
export default Paths;